import React from 'react';
type LogoProps = {
  className?: string;
};
export function Logo({
  className = ''
}: LogoProps) {
  return <span className={`flex items-center gap-2.5 font-display text-sm font-extrabold uppercase tracking-tight text-white sm:text-base ${className}`} data-id="element-116" data-mp="8td0roxl2k3x">
      <span className="flex h-7 w-7 items-center justify-center rounded-md bg-brand text-2xs font-black text-ink" data-id="element-117" data-mp="3v8nv5o3o9ofk">
        FR
      </span>
      Flag Football Ready
    </span>;
}